module.exports = __webpack_public_path__ + "static/media/home.cee907a2.svg";